import { CheckCircleOutlined, CloseCircleOutlined, WarningOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";

interface NotificationProps {
  message: string;
  messageType: string;
  onClose: () => void;
}

const Notification: React.FC<NotificationProps> = ({
  message,
  messageType,
  onClose,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`notification `}>
      {messageType == "success" ? (
        <CheckCircleOutlined className={messageType} />
      ) : messageType == "error" ? (
        <CloseCircleOutlined className={messageType} />
      ) : messageType == "warning" ? (
        <WarningOutlined className={messageType} />
      ) : <></>}
      {message}
    </div>
  );
};

export { Notification };
